export default __webpack_public_path__ + "static/media/sandboxx-gift-card-horizontal.e0a9a1ae.png";